import React, { useEffect, useRef, useState } from 'react';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
import { purchaseNotifications } from '../data/content';
type Entry = {
  name: string;
  place: string;
  minutesAgo: number;
};
export function PurchasePopup() {
  const [entry, setEntry] = useState<Entry | null>(null);
  const [dismissed, setDismissed] = useState(false);
  const indexRef = useRef(0);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const show = () => {
      const person = purchaseNotifications[indexRef.current % purchaseNotifications.length];
      indexRef.current += 1;
      setEntry({
        ...person,
        minutesAgo: 1 + Math.floor(Math.random() * 12)
      });
      hideTimer = window.setTimeout(() => setEntry(null), 6000);
    };
    const firstTimer = window.setTimeout(show, 7000);
    const interval = window.setInterval(show, 16000);
    return () => {
      window.clearTimeout(firstTimer);
      window.clearTimeout(hideTimer);
      window.clearInterval(interval);
    };
  }, [dismissed]);
  if (!entry || dismissed) return null;
  return <div className="fixed bottom-24 left-3 z-50 w-[calc(100%-1.5rem)] max-w-[330px] animate-popIn rounded-2xl border border-navy-100 bg-white p-3 shadow-[0_12px_32px_rgba(13,34,64,0.18)] sm:bottom-28 sm:left-6" role="status" aria-live="polite" data-id="element-43" data-mp="163mof8qcc0yq">
      <div className="flex items-start gap-3" data-id="element-44" data-mp="1ax7mt1vuiwyg">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-grass-500/12 text-grass-600" data-id="element-45" data-mp="n6v734uczvxb">
          <ShoppingBagIcon className="h-5 w-5" aria-hidden="true" data-id="element-46" data-mp="i8tqcqkeo8p0" />
        </div>
        <div className="min-w-0 flex-1" data-id="element-47" data-mp="x51axrzq7c4t">
          <p className="text-[13px] font-bold leading-snug text-navy-800" data-id="element-48" data-mp="x6vup2z9gy7b">
            {entry.name} <span className="font-medium text-navy-700" data-id="element-49" data-mp="s5euzasijhsb">just purchased</span>
          </p>
          <p className="truncate text-[12px] font-semibold text-teal-600" data-id="element-50" data-mp="28jerscw2arbc">GLP-1 Decision Map™</p>
          <p className="mt-0.5 text-[11px] text-navy-700/60" data-id="element-51" data-mp="23m6asfmngtbo">
            {entry.place} · {entry.minutesAgo} min ago
          </p>
        </div>
        <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="-mr-1 -mt-1 rounded-lg p-1 text-navy-700/40 transition-colors duration-150 ease-out hover:bg-navy-50 hover:text-navy-700" data-id="element-52" data-mp="2aqnsos081v5c">
          <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-53" data-mp="2plbzc9hcyzmj" />
        </button>
      </div>
    </div>;
}